jQuery(function($){

// PUT ALL CODES BELOW
  
  $('.product-category-menu').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    centerMode: false,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $('.product-category-item').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    centerMode: false,
    variableWidth: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  
  
  
  $('.product-category-menu a').on('click', function(e){
	e.preventDefault();
    var targetSlide = $(this).data('targetslide');
    $('.product-category-item').removeClass('active');
    $(targetSlide).addClass('active');
    $('.product-category-menu a').removeClass('active');
    $(this).addClass('active');
  });
  
  $('.faq-toggle').click(function(e) {
      e.preventDefault();
	  
      var $this = $(this);
      
      if ($this.next().hasClass('show')) {
          $this.removeClass('show');
          $this.next().removeClass('show');
          $this.next().slideUp(350);
      } else {
          $this.parent().parent().find('.faq-item .faq-toggle').removeClass('show');
          $this.parent().parent().find('.faq-item .faq-content').removeClass('show');
          $this.parent().parent().find('.faq-item .faq-content').slideUp(350);
          $this.next().toggleClass('show');
          $this.toggleClass('show');
          $this.next().slideToggle(350);
      }
  });

  function customResize(_t){
	window.addEventListener('resize', handleHeightChanges)
	window.addEventListener('load', handleHeightChanges)

	function handleHeightChanges(){
			var highest = 0
			const targets = [...document.querySelectorAll(_t)]

			targets.forEach(e => {
				e.removeAttribute('style')
				highest = highest < e.getBoundingClientRect().height ? e.getBoundingClientRect().height : highest
			})
			targets.forEach(e => e.style.height = highest + 'px')
	}
}


/* Add your selectors here */
['.blurb-text', '.product-category-slide-item'].forEach(selector => customResize(selector))
  
// STOP EDITING
});


